import Types from '../../reducers/app/types';

export default constants => ({
  type: Types.SET_MESSAGE_SETTINGS,
  payload: constants,
});
